import { TrashIcon } from "@heroicons/react/solid";
import { t } from "i18next";
import { Moment } from "moment-timezone";
import DropDown from "../../../components/forms/dropdown/DropDown";
import { generateFullDayTimeOptions } from "../../../services/schdeuleTimeOptionsService";

type IntervalContainerProps = {
  startTime?: string;
  setStartTime: (time: string) => void;
  endTime?: string;
  setEndTime: (time: string) => void;
  onRemove: () => void;
};

export default function IntervalContainer(props: IntervalContainerProps) {
  const { startTime, setStartTime, endTime, setEndTime, onRemove } = props;

  const TIME_OPTIONS = generateFullDayTimeOptions();

  return (
    <div className="flex items-center justify-center gap-2">
      <div className="w-full md:max-w-[192px]">
        <DropDown
          id="intervalStart"
          name="intervalStart"
          schema={{}}
          register={() => {}}
          setValue={setStartTime}
          defaultValue={startTime}
          placeholder={t("page.freeTime.from")}
          options={TIME_OPTIONS}
          cypressSelector="slotStartTime"
        />
      </div>
      <div className="text-sm text-gray-500 w-fit">-</div>
      <div className="w-full md:max-w-[192px]">
        <DropDown
          id="intervalEnd"
          name="intervalEnd"
          schema={{}}
          register={() => {}}
          setValue={setEndTime}
          defaultValue={endTime}
          cypressSelector="slotEndTime"
          placeholder={t("page.freeTime.to")}
          options={TIME_OPTIONS}
        />
      </div>
      <div>
        <TrashIcon
          data-cy="removeTimes"
          className="w-5 h-5 text-gray-400"
          onClick={onRemove}
        />
      </div>
    </div>
  );
}
